<div class="main-container">
  <div class="redeem-usp-text-container" [class.align-right]="vm.layout === 'RIGHT_ALIGNED'">
    <h1 class="redeem-usp-title" [class.text-style-light]="vm.titleStyle === 'LIGHT'">{{ vm.title }}</h1>
    <ul class="redeem-usp-list">
      <li *ngFor="let listItem of vm.bulletPoints" class="redeem-list-item" [class.text-style-light]="vm.bulletPointStyle === 'LIGHT'">
        <svg-icon key="tick" size="xs" class="tick-icon"></svg-icon>
        {{ listItem }}
      </li>
    </ul>
  </div>
  <img osnSharedUseAsPicture [imgQuery]="imgQuery" class="redeem-image" [alt]="'redeem image'" [src]="fallbackUrl" />
</div>
